export const LOCALES = '/theme/locales/';
export const IMAGES = '/theme/images/';
